import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseService} from './base.service';
import {AlertService} from './alert.service';
import {GlobalService} from './global.service';


@Injectable({
    providedIn: 'root'
})
export class YoutubeService extends BaseService {
    youtubeUrl = 'https://www.googleapis.com/youtube/v3/search?key=AIzaSyDC260-NBcXg3dqaD0sUShmflZ0EsJcJWo&channelId=UCgDt7FCugvZu0mDwjAPcC_g&part=snippet,id&order=date&maxResults=20'

    constructor(public http: HttpClient,
                public alertService: AlertService,
                public globalService: GlobalService,) {
        super(http, alertService, globalService);
    }

    getYoutubeVideos() {
        return this.http.get(this.youtubeUrl);
    }
}
